import apiPaths from '../../helpers/apiPaths';
import api from '../dashBoardv1.01';
import { status200 } from './status.utils';
import { handleResponse } from './response.utils';

const fetch = (payload, cancelToken) =>
  handleResponse('fetchShippingPrices', api.post(apiPaths.shippingPrices, payload, { ...status200, cancelToken }));

export default { fetch };
